import Client from './client';

export default class Transactions extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getOrdersByOrderNumber(organization, orderNumber, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/billing/transactions/orders/${orderNumber}`, options);
  }

}
